import React, { Component } from 'react'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Radio,
  DatePicker,
  AutoComplete,
  Icon,
  Tooltip,
  message,
  Select,
  Spin
} from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import moment from 'moment'
import { actions as followUpActions } from '../../../redux/modules/jobFunctions/jobFollowUpActions'
import { actions as userActions } from '../../../redux/modules/userActions'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import Loader from '../../common/Loader'
import { convertNamesToOption, convertToOption, filterCaseInsensitive } from '../../../util'
import { getShortcut } from '../../../util/jobFollowUps'
import history from '../../../history'
import _ from 'lodash'
const FormItem = Form.Item
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const Option = Select.Option
const propTypes = {}

class JobFollowUps extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      activeKey: '1',
      assignToType: 'user'
    }
  }

  componentDidMount() {
    this.props.jobFollowUpsRefresh({
      jobId: this.props.jobId
    })
    this.props.getUsers()
    this.props.getUserRoles()
  }

  handleShortcutData = row => {
    const { jobType, jobId } = this.props.match.params
    const followUpShortcuts = getShortcut(row, jobType, jobId)

    this.setState({
      shortcutId: followUpShortcuts.shortcutId,
      relatedId: followUpShortcuts.relatedId,
      jobLink: followUpShortcuts.jobLink
    })
  }

  handleRowClick = row => {
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'follow_up'
    })
    this.handleShortcutData(row)
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row,
      activeKey: '1',
      shortcutTitle: 'Test',
      assignToType: row.assigned_to_id ? 'user' : 'role'
    })
    this.props.getFollowUpActivities({
      followUpId: row.id
    })

    this.props.getRelatedEntity({
      followUpId: row.id
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      activeKey: '1'
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      values.actorName = `${this.props.user.firstName} ${this.props.user.lastName}`

      if (this.state.currentId === 0) {
        this.props.createFollowUp({
          jobId: this.props.jobId,
          content: values,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateFollowUp({
          jobId: this.props.jobId,
          followUpId: this.state.currentId,
          content: values,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteFollowUp({
      jobId: this.props.jobId,
      followUpId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false,
      activeKey: '1'
    })
  }

  handleShortcut = () => {
    const { jobLink } = this.state
    history.push(jobLink)
  }

  onTabChange = activeKey => {
    this.setState({ activeKey })
  }

  handleRevisionChange = value => {
    const form = this.props.form
    const revisions = JSON.parse(
      this.props.auditActions.revisions.data.find(x => x.id === value).json_patch
    )

    const foundIsUser = revisions.find(revision => revision.path === '/assigned_to_id')

    const isUser = foundIsUser && Boolean(+foundIsUser.value)

    this.setState(
      {
        assignToType: isUser ? 'user' : 'role'
      },
      () => {
        let changes = {}
        revisions.forEach(revision => {
          const fieldName = revision.path.substring(1, revision.path.length)
          const isAssignedToField =
            fieldName === 'assigned_to_id' || fieldName === 'assigned_to_role_id'
          if (!_.isNil(form.getFieldsValue()[fieldName]) || isAssignedToField) {
            if (!_.isNil(revision.value)) {
              changes[fieldName] = revision.value.toString()
            }
          }
        })
        if (changes.due_date) changes.due_date = moment(changes.due_date)
        console.log(changes)
        form.setFieldsValue(changes)
      }
    )
  }

  changeAssignedToType = e => {
    this.setState({
      assignToType: e.target.value
    })
  }

  render() {
    const { contentData } = this.state

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobFollowUpActions.followUps) {
      return <Loader />
    }

    const revisions =
      this.props.auditActions &&
      this.props.auditActions.revisions &&
      this.props.auditActions.revisions.data
    const loadingRevision = this.props.auditActions && this.props.auditActions.loading
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Follow Ups"
          okText={this.props.jobFollowUpActions.followUps ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={'80%'}
          maskClosable={false}
        >
          <Form layout="vertical">
            {contentData && (
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Status">
                    {getFieldDecorator('status', {
                      initialValue: contentData ? contentData.status : ''
                    })(
                      <RadioGroup>
                        <RadioButton value="Unopened">Unopened</RadioButton>
                        <RadioButton value="Opened">Opened</RadioButton>
                        <RadioButton value="Closed">Closed</RadioButton>
                        <RadioButton value="OVERDUE">OVERDUE</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                {contentData && (
                  <div className="col-md-3">
                    <FormItem label="Shortcut">
                      <Button icon="link" onClick={this.handleShortcut}>
                        {' '}
                        {this.state.relatedId ? this.state.relatedId : this.state.shortcutId}
                      </Button>
                    </FormItem>
                  </div>
                )}
                <div className="col-md-3">
                  <FormItem label="Revision">
                    {getFieldDecorator('revision', {
                      initialValue:
                        revisions && revisions.length > 0
                          ? revisions[revisions.length - 1].id
                          : null
                    })(
                      loadingRevision ? (
                        <Spin size="small" />
                      ) : (
                        <Select onChange={this.handleRevisionChange}>
                          {revisions &&
                            revisions.map(revision => (
                              <Option key={revision.id} value={revision.id}>
                                {revision.revision}
                              </Option>
                            ))}
                        </Select>
                      )
                    )}
                  </FormItem>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-3">
                <FormItem label="Type">
                  {contentData && contentData.type}
                  {!contentData &&
                    getFieldDecorator('type', {
                      rules: [
                        {
                          required: true,
                          message: 'There must be a type'
                        }
                      ]
                    })(
                      <Select>
                        <Option key={1} value="General">
                          General
                        </Option>
                        <Option key={2} value="Callback">
                          Callback
                        </Option>
                      </Select>
                    )}
                </FormItem>
              </div>
              <div className="col-3">
                <FormItem label="Due Date">
                  {getFieldDecorator('due_date', {
                    rules: [
                      {
                        required: true,
                        message: 'You must choose a due date'
                      }
                    ],
                    initialValue: contentData ? moment(contentData.due_date) : null
                  })(<DatePicker format="MM/DD/YYYY" placeholder="Select Time" />)}
                </FormItem>
              </div>
              <div className="col-3">
                <FormItem label="Assigned To Type">
                  {getFieldDecorator('assigned_to_type', {
                    initialValue: this.state.assignToType
                  })(
                    <RadioGroup onChange={this.changeAssignedToType}>
                      <RadioButton value="user">User</RadioButton>
                      <RadioButton value="role">Role</RadioButton>
                    </RadioGroup>
                  )}
                </FormItem>
              </div>
              <div className="col-3">
                {this.state.assignToType === 'user' && (
                  <FormItem label="Assign To User">
                    {getFieldDecorator('assigned_to_id', {
                      rules: [
                        {
                          required: this.state.assignToType === 'user' ? false : true,
                          message: 'You must assign this to someone'
                        }
                      ],
                      initialValue:
                        contentData && contentData.assigned_to_id
                          ? contentData.assigned_to_id.toString()
                          : ''
                    })(
                      <AutoComplete
                        dataSource={convertNamesToOption(
                          this.props.userActions &&
                            this.props.userActions.users &&
                            this.props.userActions.users.data
                        )}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                )}
                {this.state.assignToType === 'role' && (
                  <FormItem label="Assign To Role">
                    {getFieldDecorator('assigned_to_role_id', {
                      rules: [
                        {
                          required: this.state.assignToType === 'role' ? false : true,
                          message: 'You must assign this to someone'
                        }
                      ],
                      initialValue:
                        contentData && contentData.assigned_to_role_id
                          ? contentData.assigned_to_role_id.toString()
                          : ''
                    })(
                      <AutoComplete
                        dataSource={convertToOption(
                          this.props.userActions &&
                            this.props.userActions.roles &&
                            this.props.userActions.roles.data
                        )}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Description">
                  {getFieldDecorator('description', {
                    initialValue: contentData ? contentData.description : ''
                  })(<TextArea placeholder="Type in your note..." rows={4} />)}
                </FormItem>
              </div>
            </div>

            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Follow Ups
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Follow Up
            </div>
          </div>
        </div>
        {this.props.jobFollowUpActions.followUps && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (
                  column.Header !== undefined &&
                  rowInfo !== undefined &&
                  column.Header !== 'Related ID'
                ) {
                  this.handleRowClick(rowInfo.original)
                } else if (column.Header === 'Related ID') {
                  return false
                }
              }
            })}
            data={this.props.jobFollowUpActions.followUps.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Type',
                    id: 'type',
                    accessor: 'type',
                    maxWidth: 300,
                    Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Related ID',
                    id: 'related_id',
                    accessor: d => {
                      const { jobType, jobId } = this.props.match.params
                      const followUpShortcuts = getShortcut(d, jobType, jobId)
                      return followUpShortcuts.shortcutId ? followUpShortcuts.shortcutId : 'N/A'
                    },
                    Cell: d => {
                      const { jobType, jobId } = this.props.match.params
                      const followUpShortcuts = getShortcut(d.original, jobType, jobId)
                      return followUpShortcuts.shortcutId ? (
                        <Link to={followUpShortcuts.jobLink}>{followUpShortcuts.shortcutId}</Link>
                      ) : (
                        'N/A'
                      )
                    },
                    maxWidth: 100
                  },
                  {
                    Header: 'Assigned To',
                    id: 'assigned_to_name',
                    accessor: d => {
                      let r = ''
                      if (d.assigned_to_role_name) {
                        r = d.assigned_to_role_name
                      } else {
                        r = `${d.assigned_to_first_name} ${d.assigned_to_last_name}`
                      }

                      return r
                    },
                    Cell: d => {
                      let r = ''
                      if (d.original.assigned_to_role_name) {
                        r = d.original.assigned_to_role_name
                      } else {
                        r = `${d.original.assigned_to_first_name} ${
                          d.original.assigned_to_last_name
                        }`
                      }

                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    maxWidth: 110
                  },
                  {
                    Header: 'Due date',
                    id: 'due_date',
                    accessor: d =>
                      moment(d.due_date)
                        .endOf('day')
                        .format('M/D/YYYY'),
                    maxWidth: 110
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    Cell: row => {
                      let color = null
                      if (row.value === 'OVERDUE') {
                        color = '#ff2e00'
                      } else if (row.value === 'Closed') {
                        color = 'gray'
                      } else {
                        if (row.value === 'Opened') {
                          color = '#ffbf00'
                        } else {
                          color = '#57d500'
                        }
                      }
                      return (
                        <span>
                          <span
                            style={{
                              color: color,
                              transition: 'all .3s ease'
                            }}
                          >
                            &#x25cf;
                          </span>{' '}
                          {row.value}
                        </span>
                      )
                    },
                    maxWidth: 100
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'status',
                desc: true
              },
              {
                id: 'due_date',
                asc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobFollowUpActions, userActions, auditActions }, ownProps) => ({
  jobFollowUpActions,
  userActions,
  auditActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, followUpActions, userActions, auditActions), dispatch)
})

JobFollowUps.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobFollowUps)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobFollowUps.js